
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Transcription from '../../store/modules/transcription';
import store from '@/store/store';
import * as Diff from 'diff';

const trscModule = getModule(Transcription, store);
@Component
export default class CompleteTranscriptionDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  share = false;
  completed = false;
  requestReview = false;
  comment = '';

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit('input', value);
  }

  get prevStatus() {
    return trscModule.transcription.prevStatus;
  }

  get entry() {
    return trscModule.entry;
  }

  get disableSharing() {
    return this.entry.r18;
  }

  @Watch('value')
  setCompleted() {
    this.completed = this.prevStatus === 'completed';
  }

  async save() {
    this.show = false;
    const count = this.countAddedText();
    //console.log('count:', count);
    await trscModule.completeEditing({
      isComplete: this.completed,
      share: this.share && !this.disableSharing,
      requestReview: this.requestReview,
      comment: this.comment,
      count: count,
    });
    this.$emit('saved', count);
  }

  countAddedText(): number {
    const current = trscModule.transcription.tempText;
    const latest = trscModule.history[0];
    if (!latest) return current.length;
    const previous = latest.text;
    const diff = Diff.diffChars(previous, current);
    let count = 0;
    diff.forEach((part) => {
      //console.log(part);
      if (part.added) count += part.count;
    });
    return count;
  }
}
